import React, { createContext, useContext, useEffect, useReducer } from "react";
import { ScopeOfWorkInitialPayload, ScopeOfWorkState } from "./scope-of-work.types";
import { createInitialScopeOfWorkState, scopeOfWorkReducer } from "./scope-of-work.reducers";
import { ScopeOfWorkAction } from "./scope-of-work.actions";

interface ScopeOfWorkContextValue {
  state: ScopeOfWorkState;
  dispatch: React.Dispatch<ScopeOfWorkAction>;
}

export const ScopeOfWorkContext = createContext<ScopeOfWorkContextValue | null>(null);

export function ScopeOfWorkProvider({ children, initialPayload }: { children: React.ReactNode; initialPayload?: ScopeOfWorkInitialPayload }) {
  const [state, dispatch] = useReducer(scopeOfWorkReducer, initialPayload, createInitialScopeOfWorkState);

  useEffect(() => {
    dispatch({
      type: "SET_SERVICE_NAME_OVERRIDE",
      payload: initialPayload?.serviceNameOverride ?? "",
    });
  }, [initialPayload?.serviceNameOverride]);

  return <ScopeOfWorkContext.Provider value={{ state, dispatch }}>{children}</ScopeOfWorkContext.Provider>;
}

export function useScopeOfWork() {
  const ctx = useContext(ScopeOfWorkContext);
  if (!ctx) {
    throw new Error("useScopeOfWork must be used within ScopeOfWorkProvider");
  }
  return ctx;
}
